import React, { useState, useCallback } from "react";
import { FiCopy, FiCheck } from "react-icons/fi";

export const closeButtonStyle = {
  height: "40px",
  padding: "0 16px",
  boxSizing: "border-box",
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  backgroundColor: "#3730a3",
  color: "#ffffff",
  border: "none",
  borderRadius: "6px",
  cursor: "pointer",
  fontWeight: "600",
  marginBottom: "20px",
};

export const titleStyle = {
  color: "#3730a3",
  fontSize: "24px",
  fontWeight: "bold",
  marginBottom: "8px",
};

export const introStyle = {
  color: "#4b5563",
  fontSize: "15px",
  lineHeight: 1.6,
  marginBottom: "24px",
};

export const calloutStyle = {
  backgroundColor: "#fef3c7",
  border: "1px solid #f59e0b",
  borderRadius: "8px",
  padding: "16px 20px",
  marginBottom: "28px",
  color: "#92400e",
  fontSize: "14px",
  lineHeight: 1.6,
};

export const sectionStyle = {
  marginBottom: "36px",
};

export const h2Style = {
  color: "#3730a3",
  fontSize: "20px",
  fontWeight: "700",
  marginBottom: "12px",
  marginTop: 0,
};

export const h3Style = {
  color: "#1e293b",
  fontSize: "16px",
  fontWeight: "600",
  marginBottom: "10px",
  marginTop: "20px",
};

export const listStyle = {
  color: "#4b5563",
  fontSize: "14px",
  lineHeight: 1.7,
  paddingLeft: "20px",
  marginBottom: "12px",
};

export const linkStyle = {
  color: "#3730a3",
  wordBreak: "break-all",
};

const promptLabelStyle = {
  fontSize: "13px",
  fontWeight: "600",
  color: "#3730a3",
  marginBottom: "6px",
  marginTop: "16px",
};

const codeBlockWrapperStyle = {
  position: "relative",
  marginBottom: "12px",
};

const codeBlockStyle = {
  backgroundColor: "#1e293b",
  color: "#e2e8f0",
  padding: "14px 16px",
  paddingRight: "88px",
  borderRadius: "8px",
  fontSize: "13px",
  lineHeight: 1.5,
  overflowX: "auto",
  margin: 0,
  whiteSpace: "pre-wrap",
  wordBreak: "break-word",
  fontFamily: "ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace",
};

const copyButtonStyle = {
  position: "absolute",
  top: "10px",
  right: "10px",
  display: "inline-flex",
  alignItems: "center",
  gap: "6px",
  padding: "6px 10px",
  fontSize: "12px",
  fontWeight: "600",
  color: "#e2e8f0",
  backgroundColor: "rgba(255, 255, 255, 0.1)",
  border: "1px solid rgba(255, 255, 255, 0.2)",
  borderRadius: "6px",
  cursor: "pointer",
};

export const datasourceCardStyle = {
  backgroundColor: "#f8fafc",
  border: "1px solid #e2e8f0",
  borderRadius: "8px",
  padding: "12px 16px",
  marginBottom: "10px",
};

export const datasourceNameStyle = {
  fontFamily: "ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace",
  fontSize: "13px",
  fontWeight: "600",
  color: "#3730a3",
  marginBottom: "4px",
};

export const datasourceDescStyle = {
  fontSize: "14px",
  color: "#4b5563",
  margin: 0,
  lineHeight: 1.5,
};

export const CopyableCodeBlock = ({ text }) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = useCallback(async () => {
    try {
      await navigator.clipboard.writeText(text);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch {
      const textarea = document.createElement("textarea");
      textarea.value = text;
      textarea.style.position = "fixed";
      textarea.style.opacity = "0";
      document.body.appendChild(textarea);
      textarea.select();
      document.execCommand("copy");
      document.body.removeChild(textarea);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    }
  }, [text]);

  return (
    <div style={codeBlockWrapperStyle}>
      <button type="button" style={copyButtonStyle} onClick={handleCopy} aria-label="Copy to clipboard">
        {copied ? <FiCheck aria-hidden="true" /> : <FiCopy aria-hidden="true" />}
        {copied ? "Copied" : "Copy"}
      </button>
      <pre style={codeBlockStyle}>{text}</pre>
    </div>
  );
};

export const PromptBlock = ({ give }) => (
  <div>
    <div style={promptLabelStyle}>Give Claude This</div>
    <CopyableCodeBlock text={give} />
  </div>
);

export const GuideCloseButton = ({ onClose }) =>
  onClose ? (
    <button style={closeButtonStyle} type="button" onClick={onClose}>
      Close
    </button>
  ) : null;
